import { Memory } from "../../../api/generated";
import { getFavoriteMemories } from "../../../api/memory";
import { Path } from "../../../routes/PagePath";
import { useQuery } from "@tanstack/react-query";
import { CacheKey } from "../../../constants/CacheKey";
import { useIncrementLikedCount } from "./useIncrementLikedCount";

export const useFavoriteMemories = () => {
    const { data, isFetching } = useQuery(
        CacheKey.favoriteMemories,
        () => getFavoriteMemories(),
        {
            onError: () => {
                window.location.href = Path.error;
            },
        }
    );

    const memories = (data ?? []) as Memory[];

    const { incrementLikedCount, tempLikedMemoryIds } =
        useIncrementLikedCount(memories);

    return {
        memories,
        isMemoriesLoading: isFetching,
        incrementLikedCount,
        tempLikedMemoryIds,
    };
};
